import styled from 'styled-components';
import {
  Accordion as SemanticAccordion,
  Icon as SemanticIcon,
} from 'semantic-ui-react';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const Accordion = styled(SemanticAccordion)`
  &&& {
    .title {
      padding: 0 !important;
    }

    .active {
      padding: 0 !important;
    }
  }
`;

const ContainerRange = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Icon = styled(SemanticIcon)`
  float: right;
`;

const RangeAnswer = styled.div`
  margin-bottom: 1em;
`;

const RangeGroup = styled.div`
  display: inline-block;
  text-align: center;
  justify-content: space-between;

  position: relative;
  padding: 0 5px;

  &&& {
    input[type=radio]:checked + label:after {
      border-radius: 12px;
      width: 10px;
      height: 10px;
      position: absolute;
      top: 6px;
      left: 7px;
      content: " ";
      display: block;
      background: #A7A7A7;
    }
  }
`;

const RangeLabel = styled.label`
  display: block;
  color: #333;
  font-weight: normal;

  &::before {
    content: " ";
    display: block;
    position: relative;
    top: 4px;
    margin: 0 2px 4px 0;
    width: 14px;
    height: 14px;
    border-radius: 12px;
    border: 1px solid #ccc;
    background-color: #eee;
  }
`;

const RangeInputRadio = styled.input`
  display: none;
`;

const TaskLabel = styled(TextLayoutComponent.Header)`
  &&& {
    margin-bottom: 15px;
    font-size: 14px;
  }
`;

const TaskDuration = styled(TextLayoutComponent)`
  margin: 10px 0;
`;

const TaskNumber = styled.a``;

const TaskNumberContainer = styled(TextLayoutComponent.Bold)`
  &&& {
    margin: 15px 0px;
  }
`;

const UrlTypography = styled(TextLayoutComponent)`
  margin-top: 15px;
  margin-bottom: 15px;
  word-break: break-word;

  :first-child {
    margin-top: 15px;
  }
`;

export {
  Accordion,
  ContainerRange,
  Icon,
  RangeAnswer,
  RangeGroup,
  RangeLabel,
  RangeInputRadio,
  TaskDuration,
  TaskLabel,
  TaskNumber,
  TaskNumberContainer,
  UrlTypography,
};
